import { Fragment, useMemo } from 'react';

import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { UseShippingMethodListQueryOptions, useShippingMethodListQuery } from '~src/main/queries';

import { Ellipsis } from '../Ellipsis/Ellipsis';

interface UseCarrierTransportProductProps {
  queryOptions?: UseShippingMethodListQueryOptions;
  methodId?: string;
}

type Props = UseCarrierTransportProductProps & {
  width?: string | number;
};

export function useCarrierTransportProduct({ methodId, queryOptions }: UseCarrierTransportProductProps) {
  const { data: methods = [] } = useShippingMethodListQuery({
    customBookingMethods: queryOptions?.customBookingMethods ?? true,
    onlyConfigured: queryOptions?.onlyConfigured ?? true,
  });

  const method = useMemo(() => {
    return methods.find(m => m.id === methodId);
  }, [methods, methodId]);

  return {
    method,
  };
}

export function CarrierTransportProduct({ width, methodId, queryOptions }: Props) {
  const { method } = useCarrierTransportProduct({ methodId, queryOptions });

  if (!method?.id || !method.name) {
    return '-';
  }

  return (
    <Fragment>
      <ShippingLogo method={method.id} width={width} />
      <Ellipsis>{method.name}</Ellipsis>
    </Fragment>
  );
}
